import { render } from "./StudentCourseList.vue?vue&type=template&id=1f7de59d"
import script from "./StudentCourseList.vue?vue&type=script&lang=js"
export * from "./StudentCourseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__